export type VWOFeatureFlags = Record<VWOFlag, boolean>;

export const enum VWOFlag {
  SUMMARY_30 = 'bookingSummary30Campaign',
  FARE_CLASSES = 'bookFareClasses_FF',
  ADDONS = 'bookAddons_FF',
  SERVICE_CHARGE = 'bookServiceCharge_FF',
}

export const enum VWOGoal {
  EMAIL_OPT_IN_RADIO_BOOKING_COMPLETIONS = 'bookingEmailOptInGoal_BookingCompletions',
  EMAIL_OPT_IN_RADIO_MOVE_FORWARD = 'bookingEmailOptInGoal_MoveForward',
  SUMMARY_BOOKING_COMPLETIONS = 'bookingSummary30Goal_BookingCompletions',
  PAYMENT_MOVE = 'bookingSummary30Goal_paymentMove',
  ADDONS_BOOKING_CONVERSIONS = 'bookAddons_bookingConversionsGoal',
  ADDONS_SUMMARY_VISITS = 'bookAddons_summaryVisitsGoal',
}
